import React, { useCallback } from 'react';
import { Box, Button, CircularProgress, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Form } from './form';
import { useCreateAgency } from 'core/agencies/hooks';
import { FormProvider, useForm } from 'react-hook-form';
import { CardHeader } from 'components/cards/header';
import { AxiosError } from 'axios';


const CreatePage = () => {
    const navigate = useNavigate();

    // Form
    const methods = useForm({mode: 'onChange'});
    const { formState: { errors, dirtyFields }, reset, setError } = methods;

    // Mutation
    const mutation = useCreateAgency({
        onError: (error) => {
            toast.error("Une Erreur est survenue");

            if (error instanceof AxiosError) {
                const {full_messages, ...errors} = error.response?.data?.errors ?? {};
                Object.entries<Array<string>>(errors).forEach(([key, value]) => {
                    if (!['base'].includes(key)) { setError(key, {type: 'custom', message: value.join(', ')}); }
                });
            }
        },
        onSuccess: (responseData: any) => {
            toast.success("L'agence a été créee");
            navigate(`/dashboard/agencies/${responseData.id}`);
        }
    });
    const onFormSubmit = (data: any) => mutation.mutate({data});
    const onReset = useCallback(() => reset({}), [reset]);

    return (
        <Box component='main'>
            <FormProvider {...methods}>
                <Box component='form' onSubmit={methods.handleSubmit(onFormSubmit)} noValidate>
                    <CardHeader
                        title={`Nouvelle agence`}
                        rightComponent={(
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', my: 3, gap: '1rem' }}>
                                <Button variant='contained' color='secondary' onClick={onReset} disabled={mutation.isLoading || Object.keys(dirtyFields).length === 0}>
                                    Annuler
                                </Button>
                                <Tooltip title={Object.keys(errors).length > 0 ? 'Veuillez fixer les erreurs' : (Object.keys(dirtyFields).length === 0 ? 'Aucun champs a été modifié' : "")}>
                                    <span>
                                        <Button type='submit' variant='contained' color='primary' sx={{ color: 'white' }} disabled={mutation.isLoading || Object.keys(errors).length > 0 || Object.keys(dirtyFields).length === 0}>
                                            {mutation.isLoading && <CircularProgress size={10} />}
                                            Sauvegarder
                                        </Button>
                                    </span>
                                </Tooltip>
                            </Box>
                        )}
                    />
                    <Form />
                </Box>
            </FormProvider>
        </Box>
    );
};

export { CreatePage };